// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner_spinner__CmerI","border-clip":"Spinner_border-clip__I0VB5","rotation":"Spinner_rotation__jlwAs"};